import React, { useState } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { getMilliSecondsTimestamp } from 'utils/dateUtils';
import Link from 'components/Link';
import { TOI_LIVE_DOMAIN } from '../../../../../constants';
import SocialSharing from '../../../../articleshow_v2/components/common/SocialWidget';
import Text from '../Text';
import SponsorLogo from '../SponsoredByLogo/SponsoredBy';
import s from './TimelineItemWrapper.scss';

const TimelineItemWrapper = props => {
  const {
    data: {
      title,
      msid,
      timestamp,
      overridelink,
      metainfo = {},
      hoverridLink = '',
      updateDate = 0,
    },
    children,
    isGrid2Col,
    isSocialShare,
    isWapView,
    showTitle,
    fullPath,
    isSharedItem,
    showSocialMsid,
    gaIndex,
    utm,
    className,
    sponsorLead,
    sponsorLogo,
    sponsorUrl,
  } = props;
  const itemDisplayType =
    typeof metainfo.Sluglinebeforeheadline === 'string'
      ? metainfo.Sluglinebeforeheadline.toLowerCase()
      : '';

  let lstUpdTimeStamp;
  let itemDisplayTypeText = '';
  if (itemDisplayType === 'announcement') {
    itemDisplayTypeText = 'announcement';
  } else if (itemDisplayType === 'newsflash') {
    itemDisplayTypeText = 'news flash';
  }
  if (!timestamp && updateDate) {
    lstUpdTimeStamp = new Date(updateDate).getTime();
  }
  const validTimestamp = getMilliSecondsTimestamp(timestamp || lstUpdTimeStamp);
  const date = new Date(validTimestamp);
  const timestamp2 =
    validTimestamp + date.getTimezoneOffset() * 60 * 1000 + 330 * 60 * 1000;
  const readableTime = format(timestamp2, 'HH:mm [(IST)] MMM DD');
  const seoDate = format(validTimestamp, 'YYYY-MM-DDTHH:mm:ss+05:30');
  const pageUrl = `${TOI_LIVE_DOMAIN}${fullPath}?smsid=${msid}&`;

  const [showSocialWidget, setSocialWidget] = useState(false);
  const socialWidgetToggle = event => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    setSocialWidget(!showSocialWidget);
  };
  const socialWidgetShow = event => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
      if (
        event.target &&
        event.target.dataset &&
        event.target.dataset.socialtray === 'true'
      ) {
        setSocialWidget(true);
      }
    }
  };
  const socialWidgetHide = event => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
      if (
        event.target &&
        event.target.dataset &&
        event.target.dataset.socialtray === 'true'
      ) {
        setSocialWidget(false);
      }
    }
  };
  const showSocailFun = () => {
    if (isWapView && showSocialMsid === msid) return true;
    else if (!isWapView && showSocialWidget) return true;
    return false;
  };
  return (
    <div
      className={`${`${s.timeline_container} ${
        isWapView && className === 'optawidgetoverwrite'
          ? s.optawidgetoverwrite
          : ''
      }`} ${isGrid2Col ? '' : s.col2} ${
        isSharedItem ? s.sharedItem : ''
      }${className}`}
    >
      {!isWapView &&
        (sponsorLead || sponsorLogo) && (
          <SponsorLogo
            sponsorLead={sponsorLead}
            sponsorLogoUrl={sponsorLogo}
            sponsorCtaUrl={sponsorUrl}
            cssClass={
              isGrid2Col
                ? `${s.snippetSponsor} ${s.grid2col}`
                : s.snippetSponsor
            }
          />
        )}
      {(timestamp || lstUpdTimeStamp) &&
        readableTime && (
          <div className={s.time_text}>
            {readableTime}
            <time dateTime={seoDate} />
            <meta content={seoDate} />
          </div>
        )}
      {isWapView &&
        (sponsorLead || sponsorLogo) && (
          <SponsorLogo
            sponsorLead={sponsorLead}
            sponsorLogoUrl={sponsorLogo}
            sponsorCtaUrl={sponsorUrl}
            cssClass={s.snippetSponsor}
          />
        )}
      {itemDisplayTypeText ? (
        <div className={`${s.insert_icons} ${s[itemDisplayType]}`}>
          {itemDisplayTypeText}
        </div>
      ) : null}
      {title &&
        showTitle &&
        (overridelink || hoverridLink ? (
          <div
            className={`${s.timeline_heading} ${
              overridelink || hoverridLink ? 'cursorPointer' : ''
            }`}
          >
            <Link className={s.colorBlack} to={overridelink || hoverridLink}>
              <p>{title}</p>
            </Link>
          </div>
        ) : (
          <div className={s.timeline_heading} id={`post${props.index}`}>
            <Text link={overridelink || hoverridLink} content={title}  index={props.index}/>
          </div>
        ))}
      <div className={s.insert}>{children}</div>
      <div className={s.action_wrapper}>
        {(overridelink || hoverridLink) && (
          <Link
            className={s.readmore}
            to={overridelink || hoverridLink}
            data-newga={`${props.gaCategory}#read_full_story#updateClick_${
              props.index
            }_${overridelink || hoverridLink}`}
            data-setgacategory
          >
            READ FULL STORY
          </Link>
        )}
        {isSocialShare &&
          msid && (
            <div
              data-socialtray
              className={`${s.timelineshare}`}
              // onClick={isWapView && socialWidgetToggle}
              onMouseEnter={!isWapView && socialWidgetShow}
              onMouseLeave={!isWapView && socialWidgetHide}
            >
              {showSocailFun() && (
                <SocialSharing
                  msid={msid}
                  title={title}
                  styles={s}
                  url={pageUrl}
                  wu={pageUrl}
                  via="@timesofindia"
                  whatsAppShow={isWapView}
                  isWapView={isWapView}
                  linkeDin
                  isTablet
                  wrapperClass=""
                  gaCategory={`${props.gaCategory}`}
                  gaAction="timeline_share"
                  gaIndex={
                    typeof gaIndex !== 'undefined' ? `update_${gaIndex}_` : ''
                  }
                  utm={utm || ''}
                  socialWidgetToggle={socialWidgetToggle}
                  liveblogMailHeading="Mail this story"
                />
              )}
              <i
                data-socialtray
                className={`${s.shareicon} ${showSocailFun() ? s.active : ''}`}
                data-socialClick={msid}
              />
            </div>
          )}
      </div>
    </div>
  );
};

TimelineItemWrapper.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    timestamp: PropTypes.number,
    overridelink: PropTypes.string,
    hoverridLink: PropTypes.string,
    metainfo: PropTypes.shape({}),
  }).isRequired,
  children: PropTypes.node,
  isWapView: PropTypes.bool,
  isGrid2Col: PropTypes.bool,
  isSocialShare: PropTypes.bool,
  showTitle: PropTypes.bool,
  fullPath: PropTypes.string,
  isSharedItem: PropTypes.string,
  index: PropTypes.number,
  showSocialMsid: PropTypes.string,
  gaIndex: PropTypes.string,
  utm: PropTypes.string,
  className: PropTypes.string,
};

TimelineItemWrapper.defaultProps = {
  children: null,
  isWapView: false,
  isGrid2Col: false,
  isSocialShare: true,
  showTitle: true,
  fullPath: '',
  isSharedItem: '',
  index: '',
  showSocialMsid: '',
  gaIndex: '',
  utm: '',
  className: '',
};

export default TimelineItemWrapper;
